import { render, staticRenderFns } from "./TabListAdsAccount.vue?vue&type=template&id=f290dd4c&scoped=true&"
import script from "./TabListAdsAccount.vue?vue&type=script&lang=js&"
export * from "./TabListAdsAccount.vue?vue&type=script&lang=js&"
import style0 from "./TabListAdsAccount.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TabListAdsAccount.vue?vue&type=style&index=1&id=f290dd4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f290dd4c",
  null
  
)

export default component.exports